/**
 * @module portal\main
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhConfirmDialog from "@/components/ghConfirmDialog/ghConfirmDialog";
import { Provide, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { MethodService } from "../../utils/serviceModel";
import GhBase from "@/components/ghBase";
import * as monco from "monaco-editor";
import { WS_URL } from "@/utils/conf";

@Component
export default class Main extends GhBase {
  private mini = false;
  protected title = "";
  private drawer = false;
  private isBusy = false;
  private showMenu = false;
  private activeOpt = 0;

  private loading = false;
  private workstation: any = {};

  private history_menus: any = [];

  private menu = false;
  private noticeMessage = { isShow: false, datetime: "", message: "" };

  @State(state => state.menus)
  protected menus: IndexObject[];
  @Action("fetchMenus")
  private fetchMenus;
  @State(state => state.appconfig)
  protected appconfig: IndexObject;

  private hideMenus = [
    "main",
    "column",
    "portal.realtimemessage",
    "bi.bidiagram"
  ];

  @Watch("$route", { immediate: true })
  onUrlChange(val: any) {
    if (!this.hideMenus.includes(val.name)) {
      if (this.history_menus.findIndex(i => i.name === val.name) < 0) {
        if (this.workstation && this.workstation.PageName === val.name) {
          return;
        }
        if (
          val.meta.title !== undefined &&
          val.meta.title !== null &&
          val.meta.title !== ""
        ) {
          this.history_menus.push({
            name: val.name,
            value: val.meta.title,
            show: true
          });
        }
      }
    }
  }

  private menuNodeClick(data: IndexObject, node) {
    if (data.Url || data.dynamic) {
      let name = data.PageName ? data.PageName : data.Cd;
      this.navigate(name, data, data.Name);
    }
  }

  async created() {
    Vue.prototype.$setLoading = (flag?: boolean) => {
      if (flag) {
        this.isBusy = true;
      } else {
        this.isBusy = false;
      }
    };
    await this.loadAsyncComponents();
    this.registSnippet();
    this.getWorkstation();
    this.registerWebsocket();
  }

  mounted() {
    let dlg = this.$refs.confirmDialog as GhConfirmDialog;
    Vue.prototype.$dialogConfirm = dlg.dialogConfirm;
  }

  private async getMenus() {
    this.loading = true;
    await this.fetchMenus();
    this.loading = false;
  }
  /**
   * 加载异步组件
   */
  private async loadAsyncComponents() {
    await this.svGetCodes.invokeAsyn();
    if (this.svGetCodes.isSuccess) {
      let coms = this.svGetCodes.data as IndexObject[];
      coms.forEach(obj => {
        try {
          let name = obj.Cd;
          let code = obj.Code;
          let com = {};
          eval(code);
          Vue.component(name, com);
        } catch (error) {
          console.log(error);
        }
      });
    }
  }

  private async registSnippet() {
    let service = this.svSnippet;
    try {
      await service.invokeAsyn();

      if (service.isSuccess) {
        let data = service.data[1] as IndexObject[];

        for (const iterator of data) {
          monco.languages.registerCompletionItemProvider(iterator.Language, {
            provideCompletionItems(model, position, context, token) {
              let item = {
                label: iterator.Cd,
                kind: iterator.Kind,
                insertText: iterator.Snippet,
                documentation: iterator.Name
              } as monco.languages.CompletionItem;
              return {
                suggestions: [item]
              };
            }
          });
        }
      }
    } catch (error) { }
  }

  private async getWorkstation() {
    if (this.loginer.User) {
      let user = this.loginer.User as IndexObject;
      let service = this.svWorkstation;
      try {
        await service.invokeAsyn({ role: user.RoleId });
        if (service.isSuccess) {
          this.workstation = service.data as IndexObject;
          if (this.workstation) {
            this.goWorkstation();
          }
        }
      } catch (error) { }
    }
  }

  private goWorkstation() {
    if (this.workstation) {
      this.navigate(this.workstation.PageName, {}, this.workstation.Name);
    }
  }

  private goRealtimeMessage(isGo = true) {
    this.noticeMessage = {
      ...this.noticeMessage,
      isShow: false,
      datetime: "",
      message: ""
    };
    this.menu = false;
    if (isGo) {
      this.navigate("portal.realtimemessage", {}, "及时消息");
    }
  }

  private registerWebsocket() {
    if ("WebSocket" in window) {
      let self = this;
      // 打开一个 web socket
      let ws = new WebSocket(WS_URL);

      ws.onmessage = function (evt) {
        let msg = evt.data;
        try {
          let obj = JSON.parse(msg);
          if (obj) {
            let user = self.loginer.User as IndexObject;
            if (
              obj.Received.includes(user.PersonName) ||
              obj.Received.includes("system")
            ) {
              self.noticeMessage = {
                ...self.noticeMessage,
                isShow: true,
                datetime: obj.SendTime.substr(0, 19),
                message: obj.Send + ":" + obj.Message
              };
            }
          }
        } catch (error) { }
      };

      ws.onclose = function () {
        // 关闭 websocket
        console.log("连接已关闭...");
      };
    } else {
      // 浏览器不支持 WebSocket
      console.log("您的浏览器不支持 WebSocket!");
    }
  }

  private activeChange(nav) {
    this.activeOpt = nav;
  }

  private OptIcon() {
    return !this.showMenu
      ? "mdi-chevron-double-right"
      : "mdi-chevron-double-left";
  }

  private closeNav(item) {
    let s = this.history_menus.findIndex(i => i === item);
    this.history_menus.splice(s, 1);
    if (this.history_menus.length > 0) {
      if (s > this.history_menus.length - 1) {
        s -= 1;
      }
      this.navigate(
        this.history_menus[s].name,
        {},
        this.history_menus[s].value
      );
    } else {
      if (this.workstation) {
        this.goWorkstation();
      } else {
        this.navigate("main");
      }
    }
  }

  private svGetCodes: MethodService = new MethodService(
    "plat.component",
    "ComponentModel",
    "get_codes"
  );

  private svSnippet: MethodService = new MethodService(
    "dynamic_parse_page",
    "5cde0ac0d108614b2c60d83b",
    "query"
  );

  private svWorkstation: MethodService = new MethodService(
    "dynamic_parse_page",
    "5d5774e542fcab2cac928cd9",
    "query_workstation"
  );
}
